import { useState } from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { CopyIcon, LinkIcon, TrashIcon } from "@icons";
import { VariantGrid, VariantItem } from "./playgroundControls";
import styles from "./MenuPlayground.module.scss";

/** A card-like surface with right-click actions; a plain click stays the card's own. */
export const MenuPlaygroundContext = () => {
    const [lastAction, setLastAction] = useState("none");

    return (
        <VariantGrid title="Context menu" columns="three">
            <VariantItem label="Menu.Context · right-click, long-press, Shift+F10 or the Menu key">
                <Menu.Context
                    trigger={
                        <button
                            type="button"
                            className={styles.contextCard}
                            onClick={() => setLastAction("card click")}
                        >
                            Q3 close · Acme Inc.
                            <span className={styles.contextCardMeta}>
                                Last action: {lastAction}
                            </span>
                        </button>
                    }
                >
                    <Menu.Item
                        leading={<LinkIcon />}
                        onClick={() => setLastAction("open")}
                    >
                        Open
                    </Menu.Item>
                    <Menu.Item
                        leading={<CopyIcon />}
                        onClick={() => setLastAction("copy link")}
                    >
                        Copy link
                    </Menu.Item>
                    <Menu.Separator />
                    <Menu.Item
                        leading={<TrashIcon />}
                        destructive
                        onClick={() => setLastAction("delete")}
                    >
                        Delete
                    </Menu.Item>
                </Menu.Context>
            </VariantItem>
        </VariantGrid>
    );
};
